/**
 * Created by rak on 4/28/2017.
 */

'use strict';

angular.module('betosyswebapp')
  .directive('ngOnload', function () {
    return {
      restrict: 'A',
      scope: {
        callback: '&ngOnload'
      },
      link: (scope, element) => {
        element.on('load', (event) => scope.callback({ event: event }));
      }
    };
  });




// WEBPACK FOOTER //
// ./.tmp/components/common/directives/iframeOnLoadDirective.js